import { Box } from '@mui/joy';

import { usePermissionsContext } from '../context/permissionsContext';

import { Navbar } from './navbar/Navbar';

interface PropTypes {
  children: React.ReactNode;
}
const Layout = ({ children }: PropTypes) => {
  const { isVersionMismatch } = usePermissionsContext();

  const navbarHeight = 62;
  const versionMismatchHeight = isVersionMismatch ? 28 : 0;
  const totalTopOffset = navbarHeight + versionMismatchHeight;

  return (
    <>
      <Navbar />
      <Box
        id='layout'
        sx={{
          position: 'fixed',
          top: `${totalTopOffset}px`,
          mx: 'auto',
          width: 1,
          height: `calc(100vh - ${totalTopOffset}px)`,
          overflowY: 'scroll',
        }}
      >
        {children}
      </Box>
    </>
  );
};

export { Layout };
